import { createContext } from "react";

// Creem contextul pentru store-ul de favorite
export const FavoritesContext = createContext()